import React from 'react';
import { motion } from 'framer-motion';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaClock } from 'react-icons/fa';
import './Contact.css';

const Contact = () => {
  const contactInfo = [
    {
      icon: <FaPhone />,
      title: 'Call Us',
      value: '(647) 898-8242',
      link: 'tel:6478988242',
      description: 'Available 24/7 for emergency roadside assistance'
    },
    {
      icon: <FaEnvelope />,
      title: 'Email Us',
      value: 'raymond@torontoroadside.ca',
      link: 'mailto:raymond@torontoroadside.ca',
      description: 'Send us an email and we\'ll respond within 2 hours'
    },
    {
      icon: <FaMapMarkerAlt />,
      title: 'Service Area',
      value: 'Toronto, Ontario',
      link: null,
      description: 'We serve the Greater Toronto Area and surrounding regions'
    },
    {
      icon: <FaClock />,
      title: 'Availability',
      value: '24/7 Emergency Service',
      link: null,
      description: 'Round-the-clock service for all your roadside needs'
    }
  ];

  return (
    <div className="contact">
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="contact-hero-overlay"></div>
        <div className="container">
          <motion.div
            className="contact-hero-content"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="page-title">Contact Us</h1>
            <p className="page-subtitle">
              We're here to help 24/7. Reach out to us anytime you need assistance.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Contact Info Cards */}
      <section className="section contact-info-section">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="section-title">Get In Touch</h2>
            <p className="section-subtitle">
              Choose the best way to reach us for your roadside assistance needs
            </p>
          </motion.div>
          
          <div className="contact-info-grid">
            {contactInfo.map((info, index) => (
              <motion.div
                key={index}
                className="contact-info-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                whileHover={{ scale: 1.05 }}
              >
                <div className="contact-info-icon">{info.icon}</div>
                <h3 className="contact-info-title">{info.title}</h3>
                {info.link ? (
                  <a href={info.link} className="contact-info-value">
                    {info.value}
                  </a>
                ) : (
                  <p className="contact-info-value">{info.value}</p>
                )}
                <p className="contact-info-description">{info.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Emergency CTA */}
      <section className="section emergency-cta">
        <div className="container">
          <motion.div
            className="emergency-cta-content"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="emergency-cta-title">Have an Emergency?</h2>
            <p className="emergency-cta-text">
              Don't wait! Call us now for immediate roadside assistance!
            </p>
            <a href="tel:6478988242" className="btn btn-primary btn-large btn-emergency">
              <FaPhone /> Call Emergency Line: (647) 898-8242
            </a>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Contact;